/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BYPASS_MSAL } from '../interceptors/bypass-msal.token';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private baseUrl = environment.baseUrl;
  private jwtUrl = environment.jwtUrl;

  constructor(private httpClient: HttpClient) {}

  get(url: string, params?: any): Observable<any> {
    const data = {
      params,
    };
    return this.httpClient.get(this.baseUrl + url, data);
  }

  post(url: string, body?: any, params?: any): Observable<any> {
    const data = {
      ...params,
    };
    return this.httpClient.post(this.baseUrl + url, body, data);
  }

  postBlob(url: string, body: any = {}, params: any = {}): Observable<Blob> {
    return this.httpClient.post(`${this.baseUrl}${url}`, body, {
      params,
      responseType: 'blob',
      observe: 'body'
    });
  }

  put(url: string, body?: any, params?: any): Observable<any> {
    const data = {
      params,
    };
    return this.httpClient.put(this.baseUrl + url, body, data);
  }

  patch(url: string, body?: any, params?: any): Observable<any> {
    const data = {
      params,
    };
    return this.httpClient.patch(this.baseUrl + url, body, data);
  }

  delete(url: string, params?: any): Observable<any> {
    const data = {
      params,
    };
    return this.httpClient.delete(this.baseUrl + url, data);
  }

  jwtGet(url: string): Observable<any> {
    return this.httpClient.get(this.jwtUrl + url, {
      context: new HttpContext().set(BYPASS_MSAL, true),
    });
  }

  jwtPost(url: string, body?: any, options?: any): Observable<any> {
    return this.httpClient.post(this.jwtUrl + url, body, {
      context: new HttpContext().set(BYPASS_MSAL, true),
      ...options,
    });
  }
}
